import { useCallback } from 'react';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';

export const useResponsiveStyles = (styles, options = {}) => {
  const { offset = 0, component = {} } = options;

  const classes = useDefaultStyles(styles, component);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints, offset);

  const getStyles = useCallback((className) => {
    const classNameWithDisplayMode = `${className}-${displayMode}`;

    const baseStyle = classes[className];
    const responsiveStyle = classes[classNameWithDisplayMode];

    return {
      ...(baseStyle ? { [baseStyle]: true } : {}),
      ...(responsiveStyle ? { [responsiveStyle]: true } : {}),
    };
  }, [classes, displayMode]);

  return getStyles;
};
